import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ExpiredSubscriptionBannerProps {
  expireDate: string;
  onReactivate: () => void;
}

export const ExpiredSubscriptionBanner: React.FC<ExpiredSubscriptionBannerProps> = ({ expireDate, onReactivate }) => {
  // Format the expiration date
  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  return (
    <div 
      className="expired-subscription-banner rounded-lg p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 mb-6"
    >
      {/* X Icon */}
      <div className="flex-shrink-0">
        <div 
          className="expired-subscription-banner-icon w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center"
        >
          <X className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
        </div>
      </div>

      {/* Text Content */}
      <div className="flex-1 text-white">
        <h3 className="expired-subscription-banner-title mb-2">Your Subscription Has Ended</h3>
        <p className="expired-subscription-banner-description opacity-95 mb-4 sm:mb-0">
          Your SKILLSTURE PLUS subscription expired on {formatDate(expireDate)}. You've lost access to premium features, career coaching sessions, and professional networking opportunities.
        </p>
      </div>

      {/* Reactivate Button */}
      <div className="flex-shrink-0 w-full sm:w-auto">
        <Button
          onClick={onReactivate}
          className="expired-subscription-banner-button text-white transition-colors"
        >
          Reactivate Your Subscription
        </Button>
      </div>
    </div>
  );
};

